import React, {createContext} from 'react';

// Due to new version migration (16 -> 19) changed react.createContext to create context.
const AppointmentContext = createContext();

export class AppointmentProvider extends React.Component {
  state = {
    provider: {},
    tenancy: {},
    start: '',
    end: '',
    cancelToken: '',
  };

  updateAppointment = newAppt => {
    this.setState({ ...newAppt });
  };

  updateCancelToken = newCancelToken => {
    this.setState({ cancelToken: newCancelToken });
  };

  render() {
    const { children } = this.props;
    const { provider, tenancy, start, end, cancelToken } = this.state;

    return (
      <AppointmentContext.Provider
        value={{
          provider,
          tenancy,
          start,
          end,
          cancelToken,
          updateAppointment: this.updateAppointment,
          updateCancelToken: this.updateCancelToken,
        }}
      >
        {children}
      </AppointmentContext.Provider>
    );
  }
}

export const AppointmentConsumer = AppointmentContext.Consumer;

export default AppointmentContext;
